<ng-container *ngIf="this.selectedTab === 0">
  <div class="row">
    <div class="col col-1">
    </div>
    <div class="col-2 bold">
      Huidige periode
    </div>
    <div class="col-3 bold">
      Vorige periode
    </div>
  </div>
  <div class="pt-3"></div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="inventoryRawMaterialsConsumablesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Grond- en hulpstoffen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(1)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="workInProgressFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Onderhanden werk</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(2)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="inventoryFinishedTradeGoodsFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Gereed product en handelsgoederen</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(3)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="prepaymentsInventoriesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Vooruitbetalingen op voorraden</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(4)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
    <form [formGroup]="inventoriesFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px"><b>Totaal van voorraden</b></p>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<ng-container *ngIf="this.selectedTab === 1">
  <form [formGroup]="inventoriesDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over voorraden</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.inventoriesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(5)">
          {{ this.inventoriesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="inventoryRawMaterialsConsumablesDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over grond- en hulpstoffen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.inventoryRawMaterialsConsumablesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(6)">
          {{ this.inventoryRawMaterialsConsumablesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="workInProgressDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over onderhanden werk</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.workInProgressDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(7)">
          {{ this.workInProgressDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="inventoryFinishedTradeGoodsDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over gereed product en handelsgoederen</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.inventoryFinishedTradeGoodsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(8)">
          {{ this.inventoryFinishedTradeGoodsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="prepaymentsInventoriesDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over vooruitbetalingen op voorraden</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.prepaymentsInventoriesDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(9)">
          {{ this.prepaymentsInventoriesDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <!--  <form [formGroup]="inventoriesCostMethodDescriptionFg">-->
  <!--      <div class="row">-->
  <!--        <div class="col col-1" style="width: 400px">-->
  <!--          <p style="padding: 6px">Beschrijving van kostprijsmethode van voorraden</p>-->
  <!--        </div>-->
  <!--        <div class="col-2">-->
  <!--          <snelstart-ui-button type="secondary"-->
  <!--                               icon="{{ this.inventoriesCostMethodDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"-->
  <!--                               class="custom-input-150"-->
  <!--                               (click)="this.showDialog(10)">-->
  <!--           {{ this.inventoriesCostMethodDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}-->
  <!--          </snelstart-ui-button>-->
  <!--        </div>-->
  <!--        @if (isRechtspersoon) {-->
  <!--          <div class="col-3">-->
  <!--            <snelstart-ui-select-form-control formControlName="includeInKvkReport"-->
  <!--                                              [options]="this.optionsJaNee"-->
  <!--                                              [required]=true-->
  <!--                                              class="me-1 custom-input-150"-->
  <!--                                              (change)="this.saveForm()"-->
  <!--            >-->
  <!--            </snelstart-ui-select-form-control>-->
  <!--          </div>-->
  <!--        }-->
  <!--      </div>-->
  <!--  </form>-->
</ng-container>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.inventoryRawMaterialsConsumablesFg"
                                                       [title]="'grond- en hulpstoffen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 2">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.workInProgressFg"
                                                       [title]="'onderhanden werk'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 3">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.inventoryFinishedTradeGoodsFg"
                                                       [title]="'gereed product en handelsgoederen'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 4">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.prepaymentsInventoriesFg"
                                                       [title]="'vooruitbetalingen op voorraden'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>
<div *ngIf="this.index === 5">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.inventoriesDisclosureFg"
                                                               [title]="'Informatieverschaffing over voorraden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 6">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.inventoryRawMaterialsConsumablesDisclosureFg"
                                                               [title]="'Informatieverschaffing over grond- en hulpstoffen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 7">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.workInProgressDisclosureFg"
                                                               [title]="'Informatieverschaffing over onderhanden werk'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 8">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.inventoryFinishedTradeGoodsDisclosureFg"
                                                               [title]="'Informatieverschaffing over gereed product en handelsgoederen'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 9">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.prepaymentsInventoriesDisclosureFg"
                                                               [title]="'Informatieverschaffing over vooruitbetalingen op voorraden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 10">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.inventoriesCostMethodDescriptionFg"
                                                               [title]="'Beschrijving van kostprijsmethode van voorraden'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

